export const redispatchEvent = (element: Element, event: Event): boolean => {
  if (event.bubbles && (!element.shadowRoot || event.composed)) {
    event.stopPropagation()
  }

  const copy = Reflect.construct(event.constructor, [event.type, event])
  const dispatched = element.dispatchEvent(copy)
  if (!dispatched) {
    event.preventDefault()
  }

  return dispatched
}
